<sb-modal-template [templateId]="templateId">
  <div modal-header>
    <h5 class="modal-title">{{ options.title }} </h5>
  </div>
  <div modal-body>
    <p>{{ options.message }}</p>
  </div>
  <div modal-footer>
    <button *ngFor="let option of options.choices" class="btn btn-primary ml-1"
            (click)="onOption(option.value)">
      {{option.title}}
    </button>
  </div>
</sb-modal-template>



